import React, { FC, useContext } from 'react';
import styled from 'styled-components';

import { breakpoints } from 'helpers/styles/constants';
import type { Step } from 'components/OnboardingForm/OnboardingSteps';

const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  counter-reset: progress-nav;

  @media ${breakpoints.smUp} {
    display: block;
  }
`;

interface ProgressNavContext {
  activeStep?: Step;
}

export const ProgressNavContext = React.createContext<ProgressNavContext>({});

export const useProgressNavContext = () => useContext(ProgressNavContext);

interface Props {
  activeStep: Step;
}

const ProgressNav: FC<Props> = ({ activeStep, children }) => (
  <ProgressNavContext.Provider value={{ activeStep }}>
    <Nav>{children}</Nav>
  </ProgressNavContext.Provider>
);

export default ProgressNav;
